import Helper from './Helper/Helper';
export default {
	install(Vue) {
		Vue.filter('currency', (input, currencyCode, options = {}) => {
			return Helper.toCurrency(input, currencyCode, { ...options })
		})
		Vue.filter('currencySuffixCode', (input, currencyCode, options = {}) => {
			return Helper.toCurrency(input, currencyCode, { isSuffixCode: true, ...options })
		})
		Vue.filter('currencySuffixSign', (input, currencyCode, options = {}) => {
			return Helper.toCurrency(input, currencyCode, { isSuffixSign: true, ...options })
		})
		Vue.filter('currencyPrefixCode', (input, currencyCode, options = {}) => {
			return Helper.toCurrency(input, currencyCode, { isPrefixCode: true, ...options })
		})
		Vue.filter('currencyPrefixSign', (input, currencyCode, options = {}) => {
			return Helper.toCurrency(input, currencyCode, { isPrefixSign: true, ...options })
		})
		Vue.filter('currencySuffixTextThEn', (input, currencyCode, options = {}) => {
			return Helper.toCurrency(input, currencyCode, { isSuffixText: true, isThEn: true, ...options })
		})
		Vue.filter('currencySuffixText', (input, currencyCode, options = {}) => {
			return Helper.toCurrency(input, currencyCode, { isSuffixText: true, ...options })
		})
	}
}
